export const TOOLTIP_COMMON_PROPS = {
    moveBy: { x: 0, y: 2 },
    appendTo: 'scrollParent',
    placement: 'top',
};
//# sourceMappingURL=tooltipCommonProps.js.map